export const shimTextEncoding = async () => {
  const { TextDecoder, TextEncoder } = await import('text-encoding');
  window.TextDecoder = TextDecoder;
  window.TextEncoder = TextEncoder;
};
